module.exports = __webpack_public_path__ + "img/leader-board-header.7e9e5e41.png";